import { render, staticRenderFns } from "./userLogin.vue?vue&type=template&id=0cd00c33&scoped=true&"
import script from "./userLogin.vue?vue&type=script&lang=js&"
export * from "./userLogin.vue?vue&type=script&lang=js&"
import style0 from "./userLogin.vue?vue&type=style&index=0&id=0cd00c33&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd00c33",
  null
  
)

export default component.exports